// @flow

import { all, put, takeEvery, call } from "redux-saga/effects";
import { delay as sagaDelay } from "redux-saga";
import type { Action } from "redux-action";
import http from "@http";
import actionCreators from "@modules/employee/actionCreator";
import { AddEmployee } from "@modules/employee/constants/actions";
import type { EmployeeFormData } from "@modules/employee/types";
import { sendSuccessMessage } from "@modules/app/actionCreator";
import { LOCATION_CHANGE, push } from "connected-react-router";
import { route } from "@routes/helper";

type AddEmployeeRequest = $Exact<{
  clientId: string,
  formData: EmployeeFormData,
  recordingContext?: boolean,
}>;

export function* onAddEmployee({
  payload,
}: Action<AddEmployeeRequest>): Generator<*, void, Object> {
  try {
    if (!payload || !payload.clientId || !payload.formData) {
      throw Error(`Invalid payload provided:\n\n${JSON.stringify(payload, null, 2)}\n\n`);
    }
    yield put(actionCreators.EmployeeStartLoading());

    const response = yield call(
      http.post,
      `/api/v1/employee-admin/client/${payload.clientId}/employee`,
      payload.formData,
    );

    yield all([
      put(actionCreators.EmployeeStartLoading()),
      put(actionCreators.ToggleAddEmployeeModal(false)),
      put(
        push(
          route("REPORTING_EMPLOYEE_DETAILS_PATH", {
            clientId: response.data.client.id,
            employeeId: response.data.id,
          }),
        ),
      ),

      put(actionCreators.EmployeeStopLoading()),
    ]);
    yield call(sagaDelay, 500);
    yield put(actionCreators.ToggleAddEmployeePositionModal(true));
  } catch (e) {
    yield put(actionCreators.getAddEmployeeError(e.response));
  }
}

export function* EmployeeSearchSagas(): Generator<*, void, void> {
  yield all([takeEvery(AddEmployee, onAddEmployee)]);
}

export default EmployeeSearchSagas;
